import { render, staticRenderFns } from "./jyj_zydltj.vue?vue&type=template&id=53de253e&scoped=true"
import script from "./jyj_zydltj.vue?vue&type=script&lang=js"
export * from "./jyj_zydltj.vue?vue&type=script&lang=js"
import style0 from "./jyj_zydltj.vue?vue&type=style&index=0&id=53de253e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX-JYJ\\WEB\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53de253e",
  null
  
)

export default component.exports